import * as React from 'react';

interface LoaderSizeProps {
  loading?: boolean;
  color?: string;
  speedMultiplier?: number;
  cssOverride?: React.CSSProperties;
  size?: number | string;
}

const ClipLoader = ({
  loading = true,
  color = "#000000",
  speedMultiplier = 1,
  size = 35,
  cssOverride = {},
  ...additionalprops
}: LoaderSizeProps): JSX.Element | null => {
  if (!loading) {
    return null;
  }

  // Dynamic styles
  const loaderStyle: React.CSSProperties = {
    width: typeof size === 'number' ? `${size}px` : size,
    height: typeof size === 'number' ? `${size}px` : size,
    borderWidth: typeof size === 'number' ? `${size / 10}px` : '3.5px', // Border size based on loader size
    borderTopColor: color,
    borderBottomColor: "transparent",
    borderLeftColor: color,
    borderRightColor: color,
    animationFillMode: "both",
    ...cssOverride,
  };

  return <span className="clip-loader" style={loaderStyle} {...additionalprops}></span>;
};

export default ClipLoader;
